import type { SVGProps } from "react";
import { WHATSAPP_ICON_PATH } from "@/content/integrations";

interface BrandIconProps extends SVGProps<SVGSVGElement> {
  path: string;
}

/** Ícone de marca em SVG (paths do Simple Icons, viewBox 24×24). */
export const BrandIcon = ({ path, ...props }: BrandIconProps) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" {...props}>
    <path d={path} />
  </svg>
);

export const WhatsAppIcon = (props: SVGProps<SVGSVGElement>) => <BrandIcon path={WHATSAPP_ICON_PATH} {...props} />;
